exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vlCheck[data-v-43ff4103] {\n  display: none;\n}\n.vlSelected .vlText[data-v-43ff4103] {\n  font-weight: bold;\n}\n.vlSelected .vlCheck[data-v-43ff4103] {\n  display: block;\n}", ""]);

// exports
